export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7075.a897669b.jpg";